import React, { useState } from 'react';
import { Drawer, Link, Tabs } from 'tdesign-react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { getConfigList } from '@/services/bookkeeperService';
import ModalHeader from '@/components/Header/Modal';
import Configuration from '@/components/Cluster/Configuration';
import Logs from '@/pages/Cluster/components/Logs';
import { getCurrentCluster } from '@/pages/Layout/MenuLayout/CulsterAddon';
import Summary from '../Summary';

const { TabPanel } = Tabs;

function Detail({ detail, clusterName, currentCluster }) {
  const [visible, setVisible] = useState(false);
  const handleClose = () => setVisible(false);

  return (
    <>
      <Link theme='primary' onClick={() => setVisible(true)}>
        {detail.host}
      </Link>
      <Drawer
        visible={visible}
        destroyOnClose
        size={1000}
        header={
          <ModalHeader tags={[clusterName, `${detail.host}:${detail.port}`, detail.version]}>
            Bookie
          </ModalHeader>
        }
        footer={null}
        onOverlayClick={handleClose}
        onClose={handleClose}
      >
        <Body>
          <Summary overview={detail} />
          <Tabs defaultValue={1}>
            <TabPanel style={{ paddingTop: 20 }} value={1} label='Configuration' destroyOnHide>
              <Configuration
                configListService={() =>
                  getConfigList({
                    clusterName,
                    bookieHost: `${detail.host}:${detail.metricsPort}`,
                  })
                }
                noHide
                noOperate
              />
            </TabPanel>
            {currentCluster?.deployEnv === 'vm' && (
              <TabPanel value={3} label='日志' destroyOnHide>
                <Logs host={detail.host} type='pulsar-bookie' />
              </TabPanel>
            )}
          </Tabs>
        </Body>
      </Drawer>
    </>
  );
}

export default connect((state) => ({
  currentCluster: getCurrentCluster(state.cluster.allList),
}))(Detail);

const Body = styled.div`
  margin-top: -15px;
`;
